import { createFileRoute, redirect } from '@tanstack/react-router';

/** Moved into the Contacts hub as the "Groups" tab. Redirect keeps old links
 *  and bookmarks working. */
export const Route = createFileRoute('/vendor/contact-groups')({
  beforeLoad: () => {
    throw redirect({ to: '/vendor/contacts', search: { tab: 'groups' } });
  },
});
